module.exports = __webpack_public_path__ + "static/martin-motor-sports-logo-b28d3bf771fb8c731af915f7d44fdcdd.jpg";